import agent from './agent';
import call from './call';
import me from './me';
import session from './session';
import tasks from './tasks';
import job from './job';
import app from './app';

export const reducers = {
  agent,
  me,
  session,
  tasks,
  call,
  job,
  app
};
